import React from 'react';
import styled from 'styled-components';

import { colors } from '@ovpn-ui/styles';
import { Text, TextProps } from '@ovpn-ui/core';

/** @CRUTCH the container that should stop propagating events to the parent element */
// TODO fix interactive tooltip from shared not working
const NonInteractiveContainer = styled.div`
    margin: -8px -10px;
    padding: 8px 10px;
`;

const handleClick = (e: React.MouseEvent<Element>) => {
    e.stopPropagation();
};

const makeAccessDescription = (params: Partial<TextProps>) => (
    <>
        <Text {...params}>
            <b>Split Tunnel On (Level-1 Security)</b> — Private and <i>trusted internet traffic</i>{' '}
            is tunneled, all other internet traffic uses local internet.
        </Text>
        <br />
        <Text {...params}>
            <b>Split Tunnel Off (Level-2 Security)</b> — All traffic is tunneled, internet traffic
            exits from selected Internet Gateways
        </Text>
        <br />
        <Text {...params}>
            <b>Restricted Internet (Level-3 Security)</b> — Private and{' '}
            <i>trusted internet traffic</i> is tunneled, all other internet traffic is blocked.
        </Text>
        <br />
        <Text {...params}>
            * Trusted internet traffic — public domains and public subnets used as routes for remote
            Networks
        </Text>
    </>
);

const accessDescription = makeAccessDescription({
    color: colors.neutralTextSubtitle,
    variant: 'textSm',
    /** In case we need to override the text styles we can do that via css */
    className: 'internet-access-description-text',
});

export const internetAccessDescription = (
    <NonInteractiveContainer onClick={handleClick}>{accessDescription}</NonInteractiveContainer>
);

const accessDescriptionWhite = {
    color: colors.neutralWhite,
    variant: 'textXs',
} as const;

export const internetAccessTableDescription = (
    <>
        <Text {...accessDescriptionWhite}>
            <b>Split Tunnel On (Level-1 Security)</b> — Private and <i>trusted internet traffic</i>{' '}
            is tunneled, all other internet traffic uses local internet.
        </Text>
        <br />
        <Text {...accessDescriptionWhite}>
            <b>Split Tunnel Off (Level-2 Security)</b> — All traffic is tunneled, internet traffic
            exits from selected Internet Gateways
        </Text>
        <br />
        <Text {...accessDescriptionWhite}>
            <b>Restricted Internet (Level-3 Security)</b> — Private and{' '}
            <i>trusted internet traffic</i> is tunneled, all other internet traffic is blocked.
        </Text>
        <br />
        <Text {...accessDescriptionWhite}>
            * Trusted internet traffic — public domains and public subnets used as routes for remote
            Networks
        </Text>
    </>
);

export const networkInternetAccessDescription = (
    <NonInteractiveContainer onClick={handleClick}>
        Define Internet Access for this Network.
        <br />
        <br />
        {accessDescription}
    </NonInteractiveContainer>
);
